import styles from './bts-2025-scrolling-banner-shared.module.scss'
import { withPublicAssetUrl } from '../../../lib/utils/cdn'

export const BTS2025ScrollingBannerContent = () => {
  const baseItems = [
    { text: 'New AI Agents', icon: 'bts-hero/chrome-star.png' },
    { text: 'New Writing Era', icon: 'bts-hero/chrome-asterisk.png' },
  ]

  const icons = ['bts-hero/chrome-star.png', 'bts-hero/chrome-asterisk.png', 'bts-hero/chrome-disc.png']

  const generateBannerItems = () => {
    const items: { text: string; icon: string }[] = []
    const repetitions = 16

    for (let i = 0; i < repetitions; i++) {
      baseItems.forEach((baseItem, baseItemIndex) => {
        items.push({
          ...baseItem,
          icon: icons[(i * baseItems.length + baseItemIndex) % icons.length],
        })
      })
    }
    return items
  }

  const bannerItems = generateBannerItems()

  const renderBannerItems = () =>
    bannerItems.map((item, index) => (
      <div key={`ai-icons-${index}`} className={styles.bannerItem}>
        <span className={styles.bannerText}>{item.text}</span>
        <div className={styles.iconWrapper}>
          <img src={withPublicAssetUrl(item.icon)} alt="" className={styles.bannerIcon} />
        </div>
      </div>
    ))

  return (
    <div className={styles.container}>
      <div className={styles.scrollingContent}>{renderBannerItems()}</div>
    </div>
  )
}
